import { useAuth } from "@/context/AuthContext";
import { UserCircle, Mail, ShieldCheck, Building2 } from "lucide-react";
import { CONTACT } from "@/components/PublicLayout";

export default function Perfil() {
  const { user } = useAuth();

  return (
    <div data-testid="portal-profile-page" className="max-w-3xl">
      <h1 className="display text-3xl sm:text-4xl font-extrabold uppercase">Perfil</h1>
      <p className="mt-1 text-sm text-zinc-500">Dados da sua conta de acesso ao portal.</p>

      <div className="mt-8 card-tactical rounded-md p-6 sm:p-8" data-testid="portal-profile-account">
        <div className="flex items-center gap-4">
          <div className="w-14 h-14 grid place-content-center border border-zinc-700 rounded-sm bg-zinc-900">
            <UserCircle className="w-8 h-8 text-orange-500" strokeWidth={1.25} />
          </div>
          <div>
            <div className="display text-2xl font-bold" data-testid="portal-profile-email">{user?.name || user?.email}</div>
            <div className="text-xs uppercase tracking-wider text-zinc-500 mt-0.5">
              Conta {user?.role === "admin" || user?.is_admin ? "administradora" : "de cliente"}
            </div>
          </div>
        </div>

        <div className="mt-7 grid sm:grid-cols-2 gap-4">
          <div className="flex items-start gap-3 rounded-sm border border-zinc-800 bg-zinc-900/50 p-4">
            <Mail className="w-4 h-4 text-orange-500 mt-0.5 shrink-0" />
            <div>
              <div className="text-xs uppercase tracking-wider text-zinc-500">E-mail de acesso</div>
              <div className="mt-1 text-sm text-zinc-200">{user?.email}</div>
            </div>
          </div>
          <div className="flex items-start gap-3 rounded-sm border border-zinc-800 bg-zinc-900/50 p-4">
            <ShieldCheck className="w-4 h-4 text-orange-500 mt-0.5 shrink-0" />
            <div>
              <div className="text-xs uppercase tracking-wider text-zinc-500">Tipo de conta</div>
              <div className="mt-1 text-sm text-zinc-200">{user?.role === "admin" || user?.is_admin ? "Administrador" : "Cliente"}</div>
            </div>
          </div>
        </div>
      </div>

      <div className="mt-6 card-tactical rounded-md p-6 sm:p-8" data-testid="portal-profile-company">
        <div className="flex items-center gap-3">
          <Building2 className="w-5 h-5 text-orange-500" strokeWidth={1.5} />
          <h2 className="display text-xl font-bold uppercase tracking-wide">Dados cadastrais</h2>
        </div>
        <p className="mt-3 text-sm text-zinc-500 leading-relaxed">
          Para atualizar razão social, CNPJ, endereço de entrega ou dados de faturamento,
          entre em contato com nossa equipe:
        </p>
        <div className="mt-4 text-sm text-zinc-300 space-y-1.5">
          <div><span className="text-zinc-500">E-mail:</span> {CONTACT.email}</div>
          <div><span className="text-zinc-500">Telefone / WhatsApp:</span> {CONTACT.phone} · {CONTACT.whatsapp}</div>
          <div><span className="text-zinc-500">Horário:</span> {CONTACT.hours}</div>
        </div>
      </div>
    </div>
  );
}
